<ng-template #itemListIndicators let-item="item" [ngTemplateType]="{ item: TMultiselectItem }">
  @if (item.value.type === 'job_status') {
    <rt-offer-status-indicator
      [offerStatus]="{ kind: 'job', status: item.value.data }"
      margin-right-small-x
    />
  }
  @if (item.imageUrl || item.initials) {
    <rt-avatar
      [type]="item.imageUrl ? 'image' : 'initials'"
      size="small-x"
      [imageSrc]="item.imageUrl ?? null"
      [initials]="item.initials"
      margin-right-small-x
      class="dropdown-avatar"
    />
  }
  @if (item.value.type === 'work_model' && WORK_MODEL_ICON_MAP[item.value.data]; as iconName) {
    <rt-icon [name]="iconName" class="work_mode_icon" margin-right-small-x />
  }
  @if (item.symbol) {
    <rt-symbol [symbol]="item.symbol ?? null" layout-align-self-center margin-right-small-x />
  }
</ng-template>

@if (inputControl && mode === 'quick') {
  <rt-select2
    #select
    [formControl]="inputControl"
    [items]="optionOptions"
    [searchControl]="searchControl"
    [disableLocalSearch]="true"
    [hiddenItems]="preselected"
    (vsUpdate)="onScrollChange($event)"
    (selection)="state$.next($event)"
    (close)="closed.emit()"
    (chipRemoved)="chipRemoved.emit()"
    (clear)="clear.emit()"
    alwaysOpen
    withSearch
    withMultiselect
  >
    <ng-template rtSelectTrigger></ng-template>
    <ng-template
      [rtSelectListItem]="select"
      let-selectCtrl
      let-item="item"
      let-isHoverState="isHoverState"
    >
      <rt-dropdown-item
        (click)="selectCtrl.select$.next(item)"
        [class.hover]="isHoverState"
        class="dropdown-item"
      >
        <rt-checkbox
          prefix
          [checked]="selectCtrl.itemSelector.isSelected(item)"
          [hasMargin]="false"
          (valueChange)="selectCtrl.select$.next(item)"
        />
        <ng-template [ngTemplateOutlet]="itemListIndicators" [ngTemplateOutletContext]="{ item }" />
        {{ item.label }}
      </rt-dropdown-item>
    </ng-template>
  </rt-select2>
}

@if (inputControl && mode === 'advanced') {
  <rt-select2
    #select
    [formControl]="inputControl"
    [items]="optionOptions"
    [searchControl]="searchControl"
    [disableLocalSearch]="true"
    [hiddenItems]="preselected"
    (vsUpdate)="onScrollChange($event)"
    (selection)="state$.next($event)"
    (close)="closed.emit()"
    (chipRemoved)="chipRemoved.emit()"
    (clear)="clear.emit()"
    withSearch
    withMultiselect
  >
    <rt-select-trigger-multi [placeholder]="placeholder" />
    <ng-template [rtSelectSelectedItem]="select" let-remove="remove" let-item="item">
      <rt-chips [text]="item.label" [showClose]="true" (close)="remove(item)">
        @if (item.imageUrl || item.initials) {
          <rt-avatar
            size="small-x"
            [type]="item.imageUrl ? 'image' : 'initials'"
            [initials]="item.initials"
            [imageSrc]="item.imageUrl!"
            prefix
          />
        }
        @if (item.value.type === 'job_status') {
          <rt-offer-status-indicator
            [offerStatus]="{ kind: 'job', status: item.value.data }"
            prefix
          />
        }
        @if (item.value.type === 'work_model') {
          <span prefix>
            @if (item.value.data === 'remote') {
              <rt-icon name="nav-careershub"></rt-icon>
            }
            @if (item.value.data === 'hybrid') {
              <rt-icon name="hybrid"></rt-icon>
            }
            @if (item.value.data === 'on_site') {
              <rt-icon name="domain"></rt-icon>
            }
          </span>
        }
      </rt-chips>
    </ng-template>
    <ng-template rtSelectSelectedItemCounter let-hiddenCount="hiddenCount">
      <rt-chips [text]="'+' + hiddenCount" [showClose]="false" />
    </ng-template>
    <ng-template
      [rtSelectListItem]="select"
      let-selectCtrl
      let-item="item"
      let-isHoverState="isHoverState"
      let-index="index"
    >
      <rt-dropdown-item
        (click)="selectCtrl.select$.next(item)"
        [class.hover]="isHoverState"
        class="dropdown-item"
      >
        <rt-checkbox
          prefix
          [checked]="selectCtrl.itemSelector.isSelected(item)"
          [hasMargin]="false"
          (valueChange)="selectCtrl.select$.next(item)"
        ></rt-checkbox>
        <ng-template [ngTemplateOutlet]="itemListIndicators" [ngTemplateOutletContext]="{ item }" />
        {{ item.label }}
      </rt-dropdown-item>
    </ng-template>
  </rt-select2>
}
